import React from 'react';
import { Input, Button, Popconfirm, DatePicker, Row, Col, Form, Table } from "antd";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';

const TreatmentCourseItems = (props) => {

    const { form } = props;

    const data = Form.useWatch("qua_trinh_dieu_tri", form) || [];

    return (
        <div>
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.List name="qua_trinh_dieu_tri">
                        {(fields, { add, remove }) => (
                            <>
                                <Table
                                    dataSource={data}
                                    columns={[
                                        {
                                            title: "Ngày",
                                            dataIndex: "ngay",
                                            width: '150px',
                                            render: (_, record, index) => (
                                                <Form.Item name={[index, "ngay"]} rules={[{ required: true, message: "Bắt buộc nhập" }]}>
                                                    <DatePicker
                                                        style={{ width: '100%' }}
                                                        format="DD/MM/YYYY"
                                                        placeholder='Chọn ngày'
                                                        allowClear={false}
                                                    />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "Diễn biến bệnh",
                                            dataIndex: "dien_bien_benh",
                                            render: (_, record, index) => (
                                                <Form.Item name={[index, "dien_bien_benh"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                    <Input.TextArea rows={3} placeholder="Nhập diễn biến bệnh" />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "Xử trí",
                                            dataIndex: "xu_tri",
                                            render: (_, record, index) => (
                                                <Form.Item name={[index, "xu_tri"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                    <Input.TextArea rows={3} placeholder="Nhập xử trí" />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "Ghi chú",
                                            dataIndex: "note",
                                            render: (_, record, index) => (
                                                <Form.Item name={[index, "note"]} rules={[{ required: false, message: "Bắt buộc nhập" }]}>
                                                    <Input.TextArea rows={3} placeholder="Nhập ghi chú" />
                                                </Form.Item>
                                            )
                                        },
                                        {
                                            title: "#",
                                            dataIndex: "actions",
                                            width: '30px',
                                            align: "center",
                                            render: (_, __, index) => (
                                                <Popconfirm
                                                    title="Xóa dòng này?"
                                                    onConfirm={() => remove(index)}
                                                    placement="topLeft"
                                                >
                                                    <DeleteOutlined className='delete-icon' />
                                                </Popconfirm>
                                            )
                                        }
                                    ]}
                                    rowKey={(record, index) => index}
                                    pagination={false}
                                    size='small'
                                    bordered={false}
                                    scroll={{
                                        x: 'max-content'
                                    }}
                                    locale={{ emptyText: "Chưa có dữ liệu" }}
                                />
                                <Button
                                    type="primary"
                                    size='default'
                                    className='w-100'
                                    onClick={() => add({
                                        ngay: moment(),
                                        dien_bien_benh: "",
                                        xu_tri: "",
                                        note: ''
                                    })}
                                    icon={<PlusOutlined />}
                                >
                                    Thêm dòng mới
                                </Button>
                            </>
                        )}
                    </Form.List>
                </Col>
            </Row>
        </div>
    );
};

export default TreatmentCourseItems;